export default __webpack_public_path__ + "static/18-e85e068ad9143ab6f03148f01ba419ae.webp";